export const locationsSk = {
  locations: {
    'Others': 'Ostatné'
  }
};
